<div class="page d-flex flex-column justify-content-start" *ngIf="user$ | async let user" fadeIn="500" [fadeInDelay]="200">
    <app-toolbar class="not-mobile" type="menu" [leftAction]="backButtonCaption" (backClick)="backClick()"></app-toolbar>
    <app-mobile-toolbar class="only-mobile" [showMenu]="true" [leftAction]="backButtonCaption" (backClick)="backClick()">
        <app-icon matTooltip="Lobby" matTooltipPosition="right" class="no-outline se-icon-button" src="back" routerLink="/"></app-icon>
    </app-mobile-toolbar>


    <div class="d-flex flex-column align-items-center flex-fill mt--34" *ngIf="profile$ | async; let profile" [class.container]="selectedTab !== 'Help' || (tabletScreen$ | async)">

        <div class="tab-bar">
            <app-text-toggle [selectedItemIndex]="tabIndex" [showDividers]="true" [items]="(tabs$ | async)!" (onSelected)="onTabChange($event)"></app-text-toggle>
            <div #videoCourseButton class="video-course-button" *ngIf="selectedTab === 'Help'">
                <p class="simple-text-button">Video course ></p>
            </div>
        </div>

        <ng-container [ngSwitch]="selectedTab">
            <app-personal *ngSwitchCase="'Personal'" class="w-100" [profile]="profile" [user]="user"></app-personal>
            <app-business *ngSwitchCase="'Business'" class="w-100" [profile]="profile" [user]="user" (changeTab)="onTabChange($event)"></app-business>
            <app-users *ngSwitchCase="'Users'" class="w-100" [businessProfile]="profile"></app-users>
            <app-help *ngSwitchCase="'Help'" [businessProfile]="profile" class="mb--20"></app-help>
        </ng-container>
    </div>

</div>
